import React, { PureComponent } from "react";
import {
  Row,
  Button,
  UncontrolledDropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
  Collapse,
  ButtonDropdown,
  ButtonGroup,
} from "reactstrap";
import { injectIntl } from "react-intl";

import { Colxx } from "../../../components/common/CustomBootstrap";
import Breadcrumb from "../../navs/Breadcrumb";
import IntlMessages from "../../../helpers/IntlMessages";
import classnames from "classnames";
import * as XLSX from "xlsx";
import * as FileSaver from "file-saver";
import ThumbListIcon from "../../../components/ThumbListIcon";
import DataListIcon from "../../../components/DataListIcon";
import { AddCommaNumber } from "../../../helpers/Utils";

const formatDatasExport = (data) => {
  let custs = [];

  for (let i = 0, j = data?.length; i < j; i++) {
    custs.push({
      Stt: i + 1,
      "Mặt hàng chuyển kho": data[i].stock,
      "Số lượng chuyển kho": data[i].quantity,
      "Giá chuyển kho": data[i].price,
      "Thành tiền": Number(data[i].quantity) * Number(data[i].price),
      "Người chuyển kho": data[i].name,
      "SĐT người chuyển kho": data[i].phone,
      "Chuyển đến kho": data[i].receiving_warehouse,
      "Mô tả chuyển kho": data[i].description,
      "Tên người vận chuyển": data[i].name_carrier,
      "SĐT người vận chuyển": data[i].phone_carrier,
      "Phương tiện vận chuyển": data[i].transportation,
      "Phí vận chuyển": AddCommaNumber(data[i].cost_transfer),
      "Tình trạng xét duyệt": data[i].status,
      "Ngày chuyển hàng": data[i].at,
    });
  }
  return custs;
};

const fileType =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
const fileExtension = ".xlsx";

const exportToCSV = ({ csvData, fileName }) => {
  const ws = XLSX.utils.json_to_sheet(csvData);
  const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
  const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  const data = new Blob([excelBuffer], { type: fileType });
  FileSaver.saveAs(data, fileName + fileExtension);
};

class PageHeading extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      dropdownSplitOpen: false,
    };
  }

  handleDownloadData = () => {
    const fileName = "Danh sách Phiếu chuyển kho";

    exportToCSV({
      csvData: formatDatasExport(this.props.data),
      fileName,
    });
  };

  toggleSplit = () => {
    this.setState((prevState) => ({
      dropdownSplitOpen: !prevState.dropdownSplitOpen,
    }));
  };

  toggleDisplayOptions = () => {
    this.setState((prevState) => ({
      displayOptionsIsOpen: !prevState.displayOptionsIsOpen,
    }));
  };

  render() {
    const { messages } = this.props.intl;
    const {
      heading,
      setting,
      match,
      totalItem,
      toggleFunc,
      isDisabledAdd,
      isDisabledDel,
      isDisabledUpdate,
      changePageSizeFunc,
      onSearchKeyFunc,
      displayMode,
      changeDisplayMode,
    } = this.props;

    // console.log('render PageHeadingComponent');
    // console.log('data: ', data);

    const startIndex = (setting.currentPage - 1) * setting.selectedPageSize;
    const endIndex = setting.currentPage * setting.selectedPageSize;

    const { displayOptionsIsOpen } = this.state;
    return (
      <Row className="list-page-heading__row">
        <Colxx xxs="12">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <div className="d-flex align-items-center">
              <h1 className="mb-0 mr-2">
                <IntlMessages id={heading} />
              </h1>
              <Breadcrumb match={match} />
            </div>
            <div className="text-zero top-right-button-container d-flex align-items-center">
              <Button
                color="outline-primary"
                className="mr-2 excel-export-pages top-right-button"
                onClick={this.handleDownloadData}
                title="Tải dữ liệu về file Excel"
              >
                <i className="simple-icon-cloud-download mr-1" />
                Excel
              </Button>

              <ButtonGroup>
                <Button
                  color="primary"
                  className={classnames("top-right-button", {
                    disable: isDisabledAdd,
                  })}
                  onClick={() => toggleFunc()}
                >
                  <IntlMessages id="pages.add-new" />
                </Button>

                {this.props.selectedItemsLength > 0 && (
                  <Button
                    color="danger"
                    className="top-right-button"
                    onClick={this.props.onHandlerDelete}
                  >
                    <i className="simple-icon-trash mr-1" />
                    <IntlMessages id="pages.delete" /> (
                    {this.props.selectedItemsLength})
                  </Button>
                )}
              </ButtonGroup>
            </div>
          </div>

          <div className="mb-2">
            <Button
              color="empty"
              className="pt-0 pl-0 d-inline-block d-md-none"
              onClick={this.toggleDisplayOptions}
            >
              <IntlMessages id="pages.display-options" />{" "}
              <i className="simple-icon-arrow-down align-middle" />
            </Button>
            <Collapse
              isOpen={displayOptionsIsOpen}
              className="d-md-block"
              id="displayOptions"
            >
              <span className=" d-none d-md-flex mr-3 d-inline-block float-md-left ">
                <a
                  href="#/"
                  className={`mr-2 view-icon ${
                    displayMode === "thumblist" ? "active" : ""
                  }`}
                  onClick={(e) => {
                    e.preventDefault();
                    changeDisplayMode("thumblist");
                  }}
                >
                  <ThumbListIcon />
                </a>
                <a
                  href="#/"
                  className={`mr-2 view-icon ${
                    displayMode === "list" ? "active" : ""
                  }`}
                  onClick={(e) => {
                    e.preventDefault();
                    changeDisplayMode("list");
                  }}
                >
                  <DataListIcon />
                </a>
              </span>
              <div className="d-block d-md-inline-block">
                {!this.props.hideSearch && (
                  <div className="search-sm d-inline-block float-md-left mr-1 mb-1 align-top">
                    <input
                      type="text"
                      name="keyword"
                      id="search"
                      placeholder={messages["warehouse.transfer-search"]}
                      onKeyPress={(e) => onSearchKeyFunc(e)}
                      onChange={(e) => onSearchKeyFunc(e)}
                    />
                  </div>
                )}
              </div>
              {displayMode === "list" ? null : (
                <div className="float-md-right">
                  <span className="text-muted text-small mr-1">{`${startIndex}-${endIndex} of ${totalItem} `}</span>
                  <UncontrolledDropdown className="d-inline-block">
                    <DropdownToggle caret color="outline-dark" size="xs">
                      {setting.selectedPageSize}
                    </DropdownToggle>
                    <DropdownMenu right>
                      {setting.pageSizes.map((size, index) => {
                        return (
                          <DropdownItem
                            key={index}
                            onClick={() => changePageSizeFunc(size)}
                          >
                            {size}
                          </DropdownItem>
                        );
                      })}
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </div>
              )}
            </Collapse>
          </div>
          {/* <Separator /> */}
        </Colxx>
      </Row>
    );
  }
}

export default injectIntl(PageHeading);
